/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module _es6ShimIterator
 */

export default '_es6-shim iterator_';
